import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=1f686dce&scoped=true"
import script from "./Heading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Heading.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Heading.vue?vue&type=style&index=0&id=1f686dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f686dce",
  null
  
)

export default component.exports